import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const FolderHardhatFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="folderHardhatFilled" ref={ref} {...props}>
    <path d="M18.009,5.87h-4.53l-2.12-2.1a.7.7,0,0,0-.52-.22H5.989a3.6,3.6,0,0,0-3.6,3.6v9.7a3.611,3.611,0,0,0,3.6,3.6h12.02a3.6,3.6,0,0,0,3.6-3.6V9.48A3.606,3.606,0,0,0,18.009,5.87Zm-6,11.68C10.2,17.55,6,17.33,6,15.29a1.324,1.324,0,0,1,1.04-1.28v-.05A4.917,4.917,0,0,1,9.6,9.62v1.72a.67.67,0,1,0,1.34,0V8.54a2.5,2.5,0,0,1,.38-.06q.33-.03.69-.03c.23,0,.46.02.68.04.12.01.25.03.37.05v2.8a.67.67,0,0,0,1.34,0V9.62a4.9,4.9,0,0,1,2.56,4.34v.05A1.324,1.324,0,0,1,18,15.29C18,17.33,13.809,17.55,12.009,17.55Zm3.52-2.47a6.915,6.915,0,0,1-3.52.72,7.013,7.013,0,0,1-3.55-.72c-.61-.3-.85-.88-.23-.79a17.968,17.968,0,0,0,3.77.3,17.76,17.76,0,0,0,3.76-.3C16.379,14.2,16.139,14.78,15.529,15.08Z" />
  </Icon>
)) as IconWithRender;

FolderHardhatFilledIcon.displayName = 'FolderHardhatFilledIcon';
FolderHardhatFilledIcon.renderIcon = (props) => (
  <FolderHardhatFilledIcon {...props} />
);
export default FolderHardhatFilledIcon;
